export const LOCALES = ['en-gb','nl-nl','nl-be','fr-be','fr-fr','fr-ma','de-de','es-es','es-ve','pl-pl','sv-se','nb-no','da-dk','fi-fi','nn-no','sv-fi']